import { render } from "./CatalogItem.vue?vue&type=template&id=6cb4caed"
import script from "./CatalogItem.vue?vue&type=script&lang=js"
export * from "./CatalogItem.vue?vue&type=script&lang=js"

import "./CatalogItem.vue?vue&type=style&index=0&id=6cb4caed&lang=scss"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/intermagtech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__